import { CSSObject, getSize, rem, SwitchProps } from '@mantine/core';
import { textVariants } from '@ui/tokens/typography/typography';
import { MantineThemeComponent } from '../../types';

const switchWidth = {
	xs: '20px',
	sm: '24px',
	md: '28px',
	lg: '32px',
	xl: '40px'
};

const handleSizes = {
	xs: rem( 12 ),
	sm: rem( 14 ),
	md: rem( 18 ),
	lg: rem( 22 ),
	xl: rem( 28 )
};

// Workaround to default styles in DesignSystem.scss that set
// ul and li list-style-type to none
const SwitchDefaultConfig: MantineThemeComponent = {
	styles: ( theme, { size }: SwitchProps ) => {
		const switchSize = size || 'md';

		const trackWidth = getSize( { size: switchSize, sizes: switchWidth } );
		const handleSize = getSize( { size: switchSize, sizes: handleSizes } );

		const textColor = 'black';
		const textDisabledColor = theme.colors.dark[ 3 ];

		return ( {
			track: {
				minWidth: trackWidth
			},
			trackLabel: {
				minWidth: `calc(${trackWidth} - ${handleSize})`
			},
			body: {
				alignItems: 'center'
			},
			label: {
				'color': textColor,
				'&[data-disabled]': {
					color: `${textDisabledColor} !important`
				}
			},
			description: {
				...( textVariants.footnote as CSSObject ),
				'color': textColor,
				'input:disabled ~ .mantine-Switch-track ~ .mantine-Switch-labelWrapper &': {
					color: textDisabledColor
				}
			}
		} )
	}
};

export default SwitchDefaultConfig;
